export class DateDigitMask {
  format(raw: string, previous = ""): string {
    const incoming = this.digitsOf(raw);
    const previousDigits = this.digitsOf(previous);
    const shrinking =
      incoming.length < previousDigits.length || raw.length < previous.length;
    const accepted = this.ingest(incoming);
    return this.withSlashes(accepted, shrinking);
  }

  private digitsOf(raw: string): string {
    return raw.replace(/\D/g, "");
  }

  private ingest(digits: string): string {
    let accepted = "";
    for (const digit of digits) {
      accepted = this.push(accepted, digit);
    }
    return accepted.slice(0, 8);
  }

  private push(current: string, digit: string): string {
    if (!/^\d$/.test(digit) || current.length >= 8) return current;
    const pos = current.length;
    if (pos === 0) {
      if (digit >= "4" && digit <= "9") return `0${digit}`;
      return digit <= "3" ? digit : current;
    }
    if (pos === 1) {
      const day = Number(`${current}${digit}`);
      return day >= 1 && day <= 31 ? `${current}${digit}` : current;
    }
    if (pos === 2) {
      if (digit >= "2" && digit <= "9") return `${current}0${digit}`;
      return digit <= "1" ? `${current}${digit}` : current;
    }
    if (pos === 3) {
      const month = Number(`${current.slice(2)}${digit}`);
      return month >= 1 && month <= 12 ? `${current}${digit}` : current;
    }
    return `${current}${digit}`;
  }

  private withSlashes(digits: string, shrinking: boolean): string {
    const day = digits.slice(0, 2);
    const month = digits.slice(2, 4);
    const year = digits.slice(4, 8);
    if (digits.length === 0) return "";
    if (digits.length < 2) return day;
    if (digits.length === 2) return shrinking ? day : `${day}/`;
    if (digits.length < 4) return `${day}/${month}`;
    if (digits.length === 4) return shrinking ? `${day}/${month}` : `${day}/${month}/`;
    return `${day}/${month}/${year}`;
  }
}
